module.exports = __webpack_public_path__ + "media/images/Immobilienbild1-0d51743d6b4ba23a82165a0539e23d87.jpg";